import script from "./violation-penalty-matrix.vue?vue&type=script&setup=true&lang=js"
export * from "./violation-penalty-matrix.vue?vue&type=script&setup=true&lang=js"

import "./violation-penalty-matrix.vue?vue&type=style&index=0&id=3350e632&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3350e632"]])

export default __exports__